import {
  Popover,
  PopoverTrigger,
  IconButton,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Flex,
} from '@chakra-ui/react';
import {
  ProductApproval,
  ProductApprovalState,
} from '@texas/api/endpoints/productApprovalsApi';
import { Icons } from '@texas/components/shared/Icons';
import { useTranslation } from 'react-i18next';
import { ProductApprovalHistoryModal } from './ProductApprovalHistoryModal';
import { PaMenu } from './PaMenu';
import { convertToEnum } from '@texas/utils/helpers/enumHelpers';
import { ProductApprovalItem } from '@texas/api/endpoints/search/searchPaTypes';

export function PaMenuPopover({
  productApproval,
  onChanged,
}: {
  productApproval: ProductApproval | ProductApprovalItem;
  onChanged: (id?: number) => void;
}) {
  const { t } = useTranslation();

  return (
    <Popover placement="left">
      <PopoverTrigger>
        <IconButton
          variant="texas-outline-light"
          size="sm"
          icon={<Icons.DotsHorizontal />}
          aria-label={t('general.history.history')}
        />
      </PopoverTrigger>
      <PopoverContent w="fit-content">
        <PopoverArrow />
        <PopoverBody>
          <Flex gap={3}>
            <PaMenu
              onChanged={onChanged}
              id={productApproval.id}
              isMatrix={productApproval.matrixNodeXValue !== null}
              state={convertToEnum(ProductApprovalState, productApproval.state)}
              linkedVariantId={productApproval.linkedVariantId}
              branchId={productApproval.branchId}
              variantId={productApproval.variantId}
              compositionGroupId={productApproval.compositionGroupId}
            />
            <ProductApprovalHistoryModal
              productApprovalId={productApproval.id}
              number={productApproval.formatNumber}
            />
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
